import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

interface ViewSectionTitleProps {
  isFirstItem?: boolean;
}

export const ViewSectionTitle = styled("p")(({ isFirstItem }: ViewSectionTitleProps) => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",

  paddingTop: isFirstItem ? "12px" : "24px",
  paddingBottom: "12px",
}));

interface SectionViewContainerProps {
  hasTitle?: boolean;
  noPadding?: boolean;
}

export const SectionViewContainer = styled("div")(
  ({ hasTitle, noPadding }: SectionViewContainerProps) => ({
    paddingTop: hasTitle || noPadding ? "0px" : "24px",
    "&:first-child": {
      "& .viewSectionTitle": {
        paddingTop: "12px !important",
      },
    },
    paddingBottom: noPadding ? "0px" : "24px",
  })
);

const styles = makeStyles(() => ({
  label: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "16px",
    fontFamily: "Manrope",
    color: "#475467",
    marginBottom: "0px",
  },
  valueLabel: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "Manrope",
    color: "#475467",
  },
}));

export default styles;
